import { c as _c } from "react/compiler-runtime";
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { calcDaysLeft } from '../../utils';
interface SearchDonationCardProps {
  businessId: number;
  slugId?: string;
  thumbnailUrl: string;
  title: string;
  institutionName: string;
  endDate?: string;
  donationAmount: number;
  achievementRate: number;
  isEnded?: boolean;
}
export function SearchDonationCard(t0) {
  const $ = _c(62);
  const {
    businessId,
    slugId,
    thumbnailUrl,
    title,
    institutionName,
    endDate,
    donationAmount,
    achievementRate,
    isEnded
  } = t0;
  let T0;
  let clampedRate;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== achievementRate || $[1] !== businessId || $[2] !== endDate || $[3] !== institutionName || $[4] !== isEnded || $[5] !== slugId || $[6] !== thumbnailUrl || $[7] !== title) {
    const daysLeft = calcDaysLeft(endDate);
    clampedRate = Math.min(Math.max(achievementRate, 0), 100);
    T0 = CustomLink;
    if ($[19] !== businessId || $[20] !== slugId) {
      t6 = DONATION_ROUTES.HOMETOWN_BUSINESS_DETAIL.pathname({
        id: slugId ?? businessId
      });
      $[19] = businessId;
      $[20] = slugId;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    t7 = `${title} 상세 페이지로 이동`;
    t8 = "flex w-full items-center gap-20 mobile-tablet:gap-14";
    if ($[22] !== thumbnailUrl || $[23] !== title) {
      t9 = <div className="relative h-120 w-160 shrink-0 overflow-hidden rounded-medium ring-1 ring-inset ring-Gray-100 mobile-tablet:h-90 mobile-tablet:w-120"><Image fill={true} sizes="(max-width: 1279px) 120px, 160px" src={thumbnailUrl} alt={title} className="object-cover" /></div>;
      $[22] = thumbnailUrl;
      $[23] = title;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    t5 = "flex min-w-0 flex-1 flex-col justify-center gap-12 mobile-tablet:gap-8";
    t4 = "flex w-full flex-col gap-2";
    t1 = "flex w-full items-center justify-between gap-8 typo-caption1";
    if ($[25] !== institutionName) {
      t2 = <span className="truncate font-600 text-Gray-600">{institutionName}</span>;
      $[25] = institutionName;
      $[26] = t2;
    } else {
      t2 = $[26];
    }
    t3 = isEnded ? <span className="shrink-0 font-400 text-Gray-550">마감</span> : <span className="shrink-0 font-400 text-Gray-550">{daysLeft.toLocaleString()}일 남음</span>;
    $[0] = achievementRate;
    $[1] = businessId;
    $[2] = endDate;
    $[3] = institutionName;
    $[4] = isEnded;
    $[5] = slugId;
    $[6] = thumbnailUrl;
    $[7] = title;
    $[8] = T0;
    $[9] = clampedRate;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    T0 = $[8];
    clampedRate = $[9];
    t1 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t10;
  if ($[27] !== t1 || $[28] !== t2 || $[29] !== t3) {
    t10 = <div className={t1}>{t2}{t3}</div>;
    $[27] = t1;
    $[28] = t2;
    $[29] = t3;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== title) {
    t11 = <p className="line-clamp-1 w-full font-500 text-Gray-900 typo-body3 mobile-tablet:line-clamp-2 mobile-tablet:typo-body4">{title}</p>;
    $[31] = title;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t4) {
    t12 = <div className={t4}>{t10}{t11}</div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t4;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  const t13 = `${clampedRate}%`;
  let t14;
  if ($[37] !== t13) {
    t14 = <div className="h-4 w-full overflow-hidden rounded-pill bg-Gray-50"><div className="h-full rounded-pill bg-O-500" style={{
        width: t13
      }} /></div>;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== donationAmount) {
    t15 = donationAmount.toLocaleString();
    $[39] = donationAmount;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== t15) {
    t16 = <span className="min-w-0 flex-1 truncate text-Gray-900">{t15}원</span>;
    $[41] = t15;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== clampedRate) {
    t17 = <span className="shrink-0 text-right text-O-500">{clampedRate}%</span>;
    $[43] = clampedRate;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== t16 || $[46] !== t17) {
    t18 = <div className="flex w-full items-center gap-4 font-600 typo-body4 mobile-tablet:typo-caption1">{t16}{t17}</div>;
    $[45] = t16;
    $[46] = t17;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== t14 || $[49] !== t18) {
    t19 = <div className="flex w-full flex-col gap-4 mobile-tablet:gap-2">{t14}{t18}</div>;
    $[48] = t14;
    $[49] = t18;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== t12 || $[52] !== t19 || $[53] !== t5) {
    t20 = <div className={t5}>{t12}{t19}</div>;
    $[51] = t12;
    $[52] = t19;
    $[53] = t5;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] !== T0 || $[56] !== t20 || $[57] !== t6 || $[58] !== t7 || $[59] !== t8 || $[60] !== t9) {
    t21 = <T0 href={t6} aria-label={t7} className={t8}>{t9}{t20}</T0>;
    $[55] = T0;
    $[56] = t20;
    $[57] = t6;
    $[58] = t7;
    $[59] = t8;
    $[60] = t9;
    $[61] = t21;
  } else {
    t21 = $[61];
  }
  return t21;
}